import instance from "./http.js";

const timeout = 10000;
const requestFunc = (method = "get", url, params) => {
  let _config = {
    url: url,
    method: method.toLowerCase(),
    timeout: timeout
  };
  if (method.toLowerCase() === "get") {
    _config.params = params;
  } else {
    _config.data = params;
  }
  // return instance(_config);
  return new Promise((resolve, reject) => {
    instance(_config)
      .then(response => {
        // resolve(typeof response.data === 'object' ? response.data : JSON.parse(response.data))
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};
export default requestFunc;